
import React from 'react';
import { Paper, withStyles } from '@material-ui/core';
import TranslateForm from './TranslateForm'
import * as Yup from "yup";
import * as actions from "./store/translateActions";
import { connect } from "react-redux";
import { BackButton, hasPermission } from '../../sc-utilities';
import History from "../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }

});

const TranslationCreate = props => {
    const { activeCustomer, translations, classes, loading, permissions } = props;
    const handleSubmit = data => {
        // Prepare the form data
        data['Translations'] = { en: data.English, de: data.German }
        delete data.English
        delete data.German
        let result = props.createTranslation({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };
    let initialValues = { Key: "", English: '', German: '' };
    let formSettings = {
        Validation: {
            Key: Yup.string().required("Required"),
        },
        FormTitle: translations['create_translation'] || "Create translation",
        ButtonSubmit: hasPermission(permissions, "translation_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    // Render form
    return (
        <Paper className={classes.root}   >
            {BackButton(translations)}
            <TranslateForm
                classes={classes}
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                loading={loading}
                translations={translations}
            ></TranslateForm>
        </Paper>
    );
};
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},

    };
};
const mapDispatchToProps = dispatch => {
    return {
        createTranslation: data => dispatch(actions.createTranslations(data)),
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TranslationCreate));
